<template>
    <PopupRouterView :showLeftIcon="true" label="Delivery Order Status Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="deliveryorderstatus"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="deliveryOrderStatusInput">


        <b-card header="Delivery Order Status" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-code" label-cols-lg="12"  label="Code" label-for="input-code" size="sm" :model.sync="model.code" :isRequired="true" :state="validateState('code')" :errorMessage="getErrorMessage(errorMessage.code, 'code')"   />
						<app-input-textbox id="fieldset-name" label-cols-lg="12"  label="Name" label-for="input-name" size="sm" :model.sync="model.name" :isRequired="true" :state="validateState('name')" :errorMessage="getErrorMessage(errorMessage.name, 'name')"   />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>



        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import DeliveryOrderStatus from '@/models/DeliveryOrderStatus/DeliveryOrderStatus';
import DeliveryOrderStatusList from '@/models/DeliveryOrderStatus/DeliveryOrderStatusList';
import DeliveryOrderStatusFilter from '@/filters/DeliveryOrderStatus/DeliveryOrderStatusFilter';

import AppInputTextbox from '@/components/AppInputTextbox';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputTextbox,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			code: {required},
			name: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				code: { required : "Code is Required."},
				name: { required : "Name is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterDeliveryOrderStatus : null,
			currentDeliveryOrderStatusPage : 1,
			deliveryOrderStatusPageSize: 10,
			sortByDeliveryOrderStatus: '',
			sortDescDeliveryOrderStatus: '',
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
		}
	},
	methods : {
		getDeliveryOrderStatus : async function(id) {
			this.isBusy = true;
			DeliveryOrderStatus.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadDeliveryOrderStatus = true;
			this.filterDeliveryOrderStatus.id = this.modelId;
			DeliveryOrderStatus.downloadDataDetail(this, this.filterDeliveryOrderStatus).then(result => {
				this.isDownloadDeliveryOrderStatus = false;
			}).catch(error => { this.isDownloadDeliveryOrderStatus = false; })
		},
		getDeliveryOrderStatuss : async function(input) {
			let filter = new DeliveryOrderStatusFilter();
			if (input != undefined) {
				filter.Name = input;
			}
			this.isDeliveryOrderStatusComboLoading = true;
			DeliveryOrderStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryOrderStatuss = result.data
				}
				this.isDeliveryOrderStatusComboLoading = false;
			})
			.catch(error => {});
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.deliveryOrderStatusInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						DeliveryOrderStatus.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'deliveryorderstatusindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						DeliveryOrderStatus.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'deliveryorderstatusindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					DeliveryOrderStatus.updateData(this, model, id)
					.catch((error) => {
						this.getDeliveryOrderStatus(id);
					});
				}
			});
		},
		onHidden() {
			this.getDeliveryOrderStatuss();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterDeliveryOrderStatus = new DeliveryOrderStatusFilter();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getDeliveryOrderStatus(id);
			} else {
				this.modelId = id;
				this.getDeliveryOrderStatus(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
